<div class="bisual-table-container">
  <h3 class="mb-4">Condiciones de categorías de ausencias</h3>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Categoría</th>
      <td mat-cell *matCellDef="let category">{{ category.name }}</td>
    </ng-container>

    <ng-container matColumnDef="days_allowed">
      <th mat-header-cell *matHeaderCellDef>Días permitidos</th>
      <td mat-cell *matCellDef="let category">{{ getDaysAllowed(category) }}</td>
    </ng-container>

    <ng-container matColumnDef="days_allowed_type">
      <th mat-header-cell *matHeaderCellDef>Tipo de días</th>
      <td mat-cell *matCellDef="let category">{{ getDaysAllowedType(category) }}</td>
    </ng-container>

    <ng-container matColumnDef="is_paid">
      <th mat-header-cell *matHeaderCellDef>Retribuida</th>
      <td mat-cell *matCellDef="let category">{{ getIsPaid(category) }}</td>
    </ng-container>

    <ng-container matColumnDef="all_day">
      <th mat-header-cell *matHeaderCellDef>Día completo</th>
      <td mat-cell *matCellDef="let category">{{ getAllDay(category) }}</td>
    </ng-container>

    <ng-container matColumnDef="requires_justification">
      <th mat-header-cell *matHeaderCellDef>Justificación</th>
      <td mat-cell *matCellDef="let category">{{ getRequiresJustification(category) }}</td>
    </ng-container>

    <ng-container matColumnDef="must_be_compensated">
      <th mat-header-cell *matHeaderCellDef>Debe compensarse</th>
      <td mat-cell *matCellDef="let category">{{ getMustBeCompensated(category) }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
